const updates = [
  { date: '07-29', title: '《我独自升级》番外篇更新至第12话', tag: '韩漫推荐', tagColor: 'bg-accent-100 text-accent-700' },
  { date: '07-29', title: '《神之塔》第三季第58话已同步上线', tag: '韩漫推荐', tagColor: 'bg-accent-100 text-accent-700' },
  { date: '07-28', title: '《斗破苍穹》年番第205话更新', tag: '国漫排行榜', tagColor: 'bg-secondary-100 text-secondary-700' },
  { date: '07-28', title: '日漫大全新增《坂本日常》全卷资源', tag: '日漫大全', tagColor: 'bg-primary-100 text-primary-700' },
  { date: '07-27', title: '《咒术回战》第262话汉化版已发布', tag: '日漫大全', tagColor: 'bg-primary-100 text-primary-700' },
  { date: '07-27', title: '国漫排行榜迎来新作《深海之下》', tag: '国漫排行榜', tagColor: 'bg-secondary-100 text-secondary-700' },
  { date: '07-26', title: '漫画分类页面优化：新增悬疑推理分区', tag: '漫画分类', tagColor: 'bg-accent-100 text-accent-700' },
  { date: '07-26', title: '《全知读者视角》第178话更新上线', tag: '韩漫推荐', tagColor: 'bg-accent-100 text-accent-700' },
  { date: '07-25', title: '土豪漫画网移动端APP v3.2版本发布', tag: '漫画大全', tagColor: 'bg-primary-100 text-primary-700' },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-3">最新动态</h2>
          <p className="text-sm text-foreground-600 max-w-xl mx-auto">
            掌握<strong>漫画大全</strong>最新更新节奏，不错过任何一部<strong>好看的漫画</strong>
          </p>
        </div>

        <div className="max-w-[900px] mx-auto">
          <div className="relative">
            <div className="absolute left-[19px] md:left-[27px] top-0 bottom-0 w-px bg-background-300/60"></div>

            <div className="space-y-6">
              {updates.map((item, i) => (
                <div key={i} className="relative flex items-start gap-4 md:gap-6 pl-12 md:pl-16">
                  <div className="absolute left-0 w-10 h-10 md:w-14 md:h-14 rounded-full bg-background-50 border-2 border-primary-200 flex items-center justify-center flex-shrink-0">
                    <span className="font-heading text-xs md:text-sm text-primary-500 whitespace-nowrap">{item.date}</span>
                  </div>

                  <div className="flex-1 bg-background-50 border border-background-200/60 rounded-xl p-4 md:p-5 hover:border-primary-200/60 transition-all cursor-pointer">
                    <div className="flex flex-col sm:flex-row sm:items-center gap-2">
                      <span className={`text-xs px-2 py-0.5 rounded-full font-medium whitespace-nowrap self-start ${item.tagColor}`}>
                        {item.tag}
                      </span>
                      <h3 className="text-sm md:text-base text-foreground-800 font-medium leading-relaxed flex-1">
                        {item.title}
                      </h3>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}